"use strict";

document.addEventListener("DOMContentLoaded", function () {
  // Check if the URL contains '#contact-form'
  if (window.location.hash === "#contact-form") {
    var targetSection = document.querySelector('.contact-form');
    if (targetSection) {
      var yOffset = -100; // Adjust this value to scroll higher (100px above the section)
      var y = targetSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  }
});